import * as actionConstants from "../../constants/action-types";

const initialState = {
    revenueByChannel: [],
    totalAndAdhocRevenue: [],
    AvgOpenEmailRate: [],
    playsRevenue: [],
    clientPlaysWithTotalRevenue: [],
    touchpointsWithRevenueByPlayId: [],
    playRevenueOverTimeCumulative: [],
    playRevenueOverTimeMonthly: [],
    touchpointsWithRevenueInfo: [],
    playWithRevenueAndCampaignInfo: [],
    touchpointsCumulativeRevenueOverTime: [],
    touchpointsMonthlyRevenueOverTime: [],
    adHocRevenueByClientId: [],
    marketingPlaysRevenueDetail: [],
    topPlaysRevenue: [],
    total_remaining_Touchcpoints: [],
    client_play_total_revenue_play_detail: [],
    design_touchpoint_id : [],
    manage_campaign_summary:[],
    manage_campaign_detail:[],
    manage_campaign_detail_adhoc:[],
}

const MarketingPlayReportsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionConstants.MARKETING_PLAY_REPORTS.GET_REVENUE_BY_CHANNEL: {
            return Object.assign({}, state, {
                revenueByChannel: action.payload
            });
        }

        case actionConstants.MARKETING_PLAY_REPORTS.GET_TOTAL_ADHOC_REVENUE: {
            return Object.assign({}, state, {
                totalAndAdhocRevenue: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.GET_AVG_OPEN_EMAIL_RATE: {
            return Object.assign({}, state, {
                AvgOpenEmailRate: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.GET_PLAYS_REVENUE: {
            return Object.assign({}, state, {
                playsRevenue: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.GET_CLIENT_PLAYS_WITH_TOTAL_REVENUE: {
            return Object.assign({}, state, {
                clientPlaysWithTotalRevenue: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.GET_TOUCHPOINTS_WITH_REVENUE_BY_PLAY_ID: {
            return Object.assign({}, state, {
                touchpointsWithRevenueByPlayId: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.GET_TOUCHPOINTS_WITH_REVENUE_BY_CLIENT_ID: {
            return Object.assign({}, state, {
                touchpointsWithRevenueByClientId: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.REVENUE_OVER_TIME_CUMULATIVE: {
            return Object.assign({}, state, {
                playRevenueOverTimeCumulative: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.REVENUE_OVER_TIME_MONTHLY: {
            return Object.assign({}, state, {
                playRevenueOverTimeMonthly: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.TOUCHPOINTS_WITH_REVENUE_INFO: {
            return Object.assign({}, state, {
                touchpointsWithRevenueInfo: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.PLAY_DETAILS_REVENUE_AVG_OPEN_RATE: {
            return Object.assign({}, state, {
                playWithRevenueAndCampaignInfo: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.TOUCHPOINTS_CUMULATIVE_REVENUE_OVER_TIME: {
            return Object.assign({}, state, {
                touchpointsCumulativeRevenueOverTime: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.TOUCHPOINTS_MONTHLY_REVENUE_OVER_TIME: {
            return Object.assign({}, state, {
                touchpointsMonthlyRevenueOverTime: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.GET_ADHOC_REVENUE_BY_CLIENT_ID: {
            return Object.assign({}, state, {
                adHocRevenueByClientId: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.GET_MARKETING_PLAYS_REVENUE_DETAIL: {
            return Object.assign({}, state, {
                marketingPlaysRevenueDetail: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.TOP_PLAYS_REVENUE: {
            return Object.assign({}, state, {
                topPlaysRevenue: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.GET_TOTAL_AND_REMAINING_TOUCHPOINTS: {
            return Object.assign({}, state, {
                total_remaining_Touchcpoints: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.GET_CLIENT_PLAYS_WITH_TOTAL_REVENUE_PLAY_DETAIL: {
            return Object.assign({}, state, {
                client_play_total_revenue_play_detail: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.DESIGN_BY_TOUCHPONT_ID: {
            return Object.assign({}, state, {
                design_touchpoint_id: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.GET_MANAGE_CAMPAIGN_SUMMARY: {
            return Object.assign({}, state, {
                manage_campaign_summary: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.GET_MANAGE_CAMPAIGN_DETAIL: {
            return Object.assign({}, state, {
                manage_campaign_detail: action.payload
            });
        }
        case actionConstants.MARKETING_PLAY_REPORTS.GET_MANAGE_CAMPAIGN_DETAIL_ADHOC: {
            return Object.assign({}, state, {
                manage_campaign_detail_adhoc: action.payload
            });
        }
        default:
            return state
    }

}

export default MarketingPlayReportsReducer